import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const markVideoCompleted = async (lessonsDetails) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.COURSEURL}/api/v2/student-progress/mark-video-completed`,
			lessonsDetails,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		console.log(response);
		return "the next video was unlocked";
	} catch (error) {
		// returning blank array after getting server and internet error
		return "some error has occured";
	}
};
